import script from "./PageProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./PageProfile.vue?vue&type=script&setup=true&lang=js"

import "./PageProfile.vue?vue&type=style&index=0&id=b071f5da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/solana-twitter/solana-twitter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b071f5da"]])

export default __exports__